import { ErrorMessage } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const CustomPhoneInput = ({
  field,
  form: { touched, errors },
  label,
  country,
  required,
  placeholder,
  countryCode,
  ...props
}) => {
  return (
    <div className="mb-2">
      <label className="mb-1">
        {/* {label} {required && <span className="font-danger">*</span>} */}
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <PhoneInput
        {...field}
        {...props}
        value={`${countryCode} ${field.value}`}
        country={country ?? "in"}
        enableSearch={false}
        countryCodeEditable={false}
        placeholder={placeholder}
        // onlyCountries={["in", "gr", "fr", "us", "de", "gb"]}
        // onlyCountries={["gr", "de", "it", "in"]}
        invalid={!!touched[field.name] && !!errors[field.name]}
        inputStyle={{
          width: "100%",
          fontSize: "0.86563rem",
          height: "calc(1.5em + 0.5rem + 6px)",
        }}
        buttonClass="form-control-sm"
      />
      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomPhoneInput;
